module.exports = __webpack_public_path__ + "static/media/events.efeeb5c1.png";